import { cn } from "@/utils/styles";
import React from "react";

type SignupStepButtonProps = {
  type?: "submit" | "button";
  disabled?: boolean;
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
};

export const SignupStepButton = React.forwardRef<HTMLButtonElement, SignupStepButtonProps>(
  ({ type = "button", disabled = false, children, className = "", onClick }, ref) => {
    return (
      <button
        ref={ref}
        type={type}
        className={cn(
          `label-medium flex select-none flex-row items-center justify-center gap-2 rounded border border-gray-dark-900 bg-gray-dark-600 px-5 py-3 transition-all`,
          disabled
            ? `pointer-events-none text-gray-dark-1200`
            : `cursor-pointer text-white hover:bg-white hover:text-black`,
          className
        )}
        onClick={onClick}
      >
        {children}
      </button>
    );
  }
);
